import { INPUT_CLASS, LABEL_CLASS, RespostasEtapa2Estado } from '../candidatoFormExternoEtapa2Page.definitions';
import CampoSimNao from './CampoSimNao';

interface EtapaCuriosidadesProps {
  respostas: RespostasEtapa2Estado;
  onChange: <K extends keyof RespostasEtapa2Estado>(campo: K, valor: RespostasEtapa2Estado[K]) => void;
}

/** `opcional`: curiosidades sem campo no perfil (decisão do RH: não obrigar). */
const CAMPOS_TEXTO: Array<{ campo: keyof RespostasEtapa2Estado; label: string; opcional?: boolean }> = [
  { campo: 'comidaBebidaFavorita', label: 'Qual a sua comida e bebida preferida?' },
  { campo: 'tempoLivre', label: 'O que você gosta de fazer no tempo livre?' },
  { campo: 'lugarQuerVisitar', label: 'Existe algum lugar especial que gostaria de visitar ou viajar?', opcional: true },
  { campo: 'corFavorita', label: 'Qual sua cor favorita?' },
  { campo: 'livroFavorito', label: 'Possui algum livro favorito?' },
  { campo: 'filmeFavorito', label: 'Qual seu filme/série favorito?' },
  { campo: 'personagemFavorito', label: 'Qual o seu personagem favorito?' },
  { campo: 'bandaCantorFavorito', label: 'Qual sua banda/cantor favorito?', opcional: true },
  { campo: 'musicaDoMomento', label: 'Qual sua música do momento?', opcional: true },
  { campo: 'praticaEsporte', label: 'Pratica algum esporte? Se sim, qual?' },
  { campo: 'talentoEspecial', label: 'Você tem algum talento especial que gostaria de compartilhar com a gente?' },
  { campo: 'metaSonho', label: 'Você tem alguma meta ou sonho que gostaria de alcançar num futuro próximo?' },
];

export default function EtapaCuriosidades({ respostas, onChange }: EtapaCuriosidadesProps) {
  return (
    <>
      <h2 className="mb-6 text-2xl font-bold text-gray-800">Curiosidades</h2>
      <div className="space-y-5">
        {CAMPOS_TEXTO.map(({ campo, label, opcional }) => (
          <div key={campo}>
            <label className={LABEL_CLASS}>
              {label}
              {opcional ? <span className="font-normal text-gray-400"> (opcional)</span> : ' *'}
            </label>
            <input
              type="text"
              className={INPUT_CLASS}
              value={(respostas[campo] as string) ?? ''}
              onChange={(e) => onChange(campo, e.target.value as RespostasEtapa2Estado[typeof campo])}
            />
          </div>
        ))}
        <CampoSimNao
          label="Tem interesse em compartilhar algumas fotos conosco?"
          valor={respostas.interesseCompartilharFotos}
          onChange={(valor) => onChange('interesseCompartilharFotos', valor)}
        />
        {respostas.interesseCompartilharFotos && (
          <CampoSimNao
            label="Você autoriza o uso das imagens em nossas ações de endomarketing?"
            valor={respostas.autorizaUsoImagens === true}
            onChange={(valor) => onChange('autorizaUsoImagens', valor)}
          />
        )}
      </div>
    </>
  );
}
